import { Popup } from "antd-mobile";
import React from "react";
import { useTranslation } from "react-i18next";

import { CustomNavBar } from "../../../../components";
import { useGetApplyRecord } from "../../hooks/event.hook";
import ApplyRecordItem from "../ApplyRecordItem";

function ApplyRecordPopup(props) {
  const { t } = useTranslation();
  const getApplyRecord = useGetApplyRecord({});
  return (
    <Popup
      className="custom-drawer-popup"
      {...props}
      position="right"
      bodyStyle={{ width: "100vw", background: "var(--main-bg)" }}
    >
      <CustomNavBar onBack={props.onClose}>{t("personal.agentList.record")}</CustomNavBar>
      <div
        style={{
          padding: "12px",
          height: "calc(100vh - 45px)",
          overflowY: "scroll",
        }}
      >
        {getApplyRecord.data?.length === 0
          ? t("normal.nodata")
          : getApplyRecord.data?.map((item, index) => {
              return <ApplyRecordItem item={item} key={"applyRecord" + index} />;
            })}
      </div>
    </Popup>
  );
}

export default ApplyRecordPopup;
